<h1 mat-dialog-title>
  {{ ("declineInvitee" | i18n) || "Mitarbeiter ablehnen" }}
</h1>
<div mat-dialog-content>
  <div class="row">
    <div class="col">
      <mat-form-field>
        <mat-label>{{ ("reason" | i18n) || "Grund" }}:</mat-label>
        <mat-select
          [(ngModel)]="reason"
          data-cy="invitee-decline-reason-select">
          <mat-option [value]="reasonEnum.CERTIFICATE_NOT_FIT">
            <span data-cy="invitee-decline-reason-option">
              {{
                ("declineReasonEnum." + reasonEnum.CERTIFICATE_NOT_FIT
                  | i18n) || "Qualifikation passt nicht"
              }}
            </span>
          </mat-option>
          <mat-option [value]="reasonEnum.BAD_PRIOR_EXPERIENCE">
            <span data-cy="invitee-decline-reason-option">
              {{
                ("declineReasonEnum." + reasonEnum.BAD_PRIOR_EXPERIENCE
                  | i18n) || "Ungenügende Leistung beim letzten Einsatz"
              }}
            </span>
          </mat-option>
          <mat-option [value]="reasonEnum.OTHER">
            {{
              ("declineReasonEnum." + reasonEnum.OTHER | i18n) ||
                "Anderer Grund"
            }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field
        *ngIf="reason == reasonEnum.OTHER"
        class="no-extra-infix-width">
        <textarea
          [(ngModel)]="reasonDescription"
          matInput
          name="description"
          [placeholder]="('description' | i18n) || 'beschreibung' | titlecase"
          style="margin-top: 10px"></textarea>
      </mat-form-field>
      <mat-checkbox
        [(ngModel)]="informInviteeOfReason"
        name="informInvitee"
        data-cy="inform-invitee-of-decline-reason">
        {{
          ("informInviteeOfReason" | i18n) || "Pooler über Grund informieren"
        }}
      </mat-checkbox>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button
    mat-button
    (click)="close()">
    {{ ("close" | i18n) || "close" | uppercase }}
  </button>
  <button
    [disabled]="reason == undefined"
    mat-button
    [mat-dialog-close]="{reason, reasonDescription, informInviteeOfReason}"
    data-cy="invitee-decline-reason-submit">
    {{ ("confirm" | i18n) || "confirm" | uppercase }}
  </button>
</div>
